import React from 'react';
import { Modal, DatePicker, Select, Form, Button, List, Divider } from 'antd';
import moment from 'moment';
import { observable, action, runInAction, toJS, computed } from 'mobx';
import { observer } from 'mobx-react';

import bet_statistic_store from '@src/Store/Pandect/MySummary/BetStatisticStore';
import login_user_store from '@store/LoginUser/LoginUserStore';

const RangePicker = DatePicker.RangePicker;
const Option = Select.Option;
const FormItem = Form.Item;
window.moment = moment;

@Form.create()
@observer
class BetStatisticModal extends React.Component {
  constructor() {
    super();

    this.search_result = {};
  }

  componentWillReceiveProps() {
    this.search_result = {};
  }

  formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  @observable
  time_str = '';

  @observable
  next_proxy_str = '';

  @observable
  search_result = {};

  @computed
  get search_result_list() {
    let str_enum = {
      nextBackMoney: '下线总提现',
      nextNum: '新增人数',
      nextOrderMoney: '下线总投注',
      nextPayment: '下线总充值',
      nextTotalWin: '下线总输赢',
      proxyAmount: '代理总返佣'
    };
    let result = [];
    let temp_obj = toJS(this.search_result);
    for(let attr in temp_obj) {
      result.push({
        str: str_enum[attr],
        data: temp_obj[attr]
      });
    }
    return result;
  }

  @observable
  submitting = false;

  @action
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields( async (error, values) => {
      if(!error) {
        // console.log( values );
        let start_time = new Date(values.time_range[0]).getStartTimestamp();
        let end_time = new Date(values.time_range[1]).getEndTimestamp();
        // debugger
        // runInAction(() => {
        //   this.submitting = true;
        //   this.search_result = {};
        // })
        let result = await bet_statistic_store.search({
          uid: bet_statistic_store.id,
          nextProxyType: values.nextProxyType,
          startTime: start_time,
          endTime: end_time
        });

        runInAction(() => {
          this.submitting = false;
        })
        if(result.success) {
          runInAction(() => {
            this.search_result = result.data;
            this.time_str = `${values.time_range[0].format('YYYY-MM-DD')}  ~  ${values.time_range[1].format('YYYY-MM-DD')}`;
            this.next_proxy_str = values.nextProxyType === 0 ? '全部下线' : '直属下线';
          })
          // message.success(`管理员 ${values.nickname} 编辑成功！`, 3);
          // 重置编辑表单
          // this.props.form.resetFields();
          // 关闭编辑弹出层
          // admin_store.closeEditModal();
          // 重新拉数据
          // admin_store.searchByFilter();
        } else {
          // message.error(`管理员 ${values.nickname} 编辑失败！${ result.error.error_data }`, 3);
        }
        return;
      }
    })
  }

  render() {
    let { getFieldDecorator } = this.props.form;

    return (
      <Modal
        visible={ bet_statistic_store.is_modal_show }
        // visible={ true }
        width='400px'
        onCancel={() => {
          bet_statistic_store.closeModal();
        }}
        title={(
          <div>
            <span>{bet_statistic_store.username} 的统计报表</span>
          </div>
        )}
        footer={ null }>
        <Form>
          <FormItem
            // label="时间选择"
            {...this.formItemLayout}>
            {
              getFieldDecorator('time_range', {
                initialValue: [moment(), moment()],
                rules: [
                  {
                    required: true,
                    message: '请选择时间范围'
                  }
                ]
              })(
                <RangePicker
                  allowClear={ false }
                  style={{
                    width: '100%'
                  }}/>
              )
            }
          </FormItem>
          <FormItem
            // label="下线选择"
            {...this.formItemLayout}>
            {
              getFieldDecorator('nextProxyType', {
                initialValue: 0,
                rules: [
                  {
                    required: true,
                    message: '请选择下线'
                  }
                ]
              })(
                <Select style={{
                  width: '100%'
                }}
                placeholder="下线选择">
                  <Option value={ 0 }>全部下线</Option>
                  <Option value={ 1 }>直属下线</Option>
                </Select>
              )
            }
          </FormItem>
          <FormItem
            // label=" "
            {...this.formItemLayout}>
            <Button
              block
              type="primary"
              onClick={ this.handleSubmit }
              loading={ this.submitting }>
              生成报表
            </Button>
          </FormItem>
        </Form>
        {
          toJS(window.isEmptyObject(this.search_result)) ? null : (
            <div >
              <div style={{
                marginBottom: '15px'
              }}>
                <span>
                  {
                    this.time_str
                  }
                </span>
                <Divider type="vertical"/>
                <span>
                  {
                    this.next_proxy_str
                  }
                </span>
              </div>
              <List
                size='small'
                bordered
                dataSource={
                  this.search_result_list
                }
                renderItem={ item => (
                  <List.Item>
                    <div style={{
                      display: 'flex',
                      width: '100%'
                    }}>
                      <span style={{
                        flex: 1
                      }}>{item.str}</span>
                      <span style={{
                        flex: 1,
                        textAlign: "right"
                      }}>{item.data}</span>
                    </div>
                  </List.Item>
                )} />
            </div>
          )
        }
      </Modal>
    );
  }

  componentDidMount() {
  }
}

export default BetStatisticModal;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Pandect/MySummary/BetStatisticModal/BetStatisticModal.jsx